export { setSliderGrafics }

function setSliderGrafics(value, thumb, fill) {
    //cause our sliders go from
    value = Math.round(value / 5);
    setThumbPosition(thumb, value);
    setSliderFill(fill, value);
}

//-- set the grafic of the overlay slider thumb to new position
function setThumbPosition(elThumb, sliderPos) {
    let thumbWidth = parseInt(
        getComputedStyle(elThumb).getPropertyValue("width")
    );
    let deviation = Math.round((sliderPos * thumbWidth) / 100);
    elThumb.style.left = `calc(${sliderPos}% - ${deviation}px)`;

}

//-- set the gradient under the slider, the one that changes when you move the thumb up and down
function setSliderFill(elFill, sliderPos) {
    let fillcolor = getComputedStyle(elFill).getPropertyValue("--accentcolor");
    let alphafillcolor = getComputedStyle(elFill).getPropertyValue(
        "--accentcoloralpha"
    );
    let gradient = `linear-gradient(to right, ${fillcolor} 0%, 
          ${alphafillcolor} ${sliderPos}%, 
          rgba(255,255,255,0.1) ${Number(sliderPos) + 1}%, 
          rgba(255,255,255,0)  100%)`;
    elFill.style.background = gradient;
}
